import { ModeSliceState } from "../slices/modeSlice";

function isNotOnGlobalPage(path?: string): boolean {
  const currentPath = path ?? (typeof window !== "undefined" ? window.location.pathname : "");
  const isDashboardOrCaLive =
    currentPath.includes("dashboard") ||
    currentPath.includes("ca-live");
  return !isDashboardOrCaLive;
}

export function isStoreMode(mode: ModeSliceState["value"], path?: string): boolean {
  return mode === "store";
}

export function isRegionMode(mode: ModeSliceState["value"], path?: string): boolean {
  return mode === 'region';
}

export function isAlertMode(mode: ModeSliceState["value"], path?: string): boolean {
  return mode === 'alert' && isNotOnGlobalPage(path);
}

export function isStoreOrAlertMode(mode: ModeSliceState["value"], path?: string): boolean {
  return isAlertMode(mode, path) || isStoreMode(mode, path);
}

export function getModeFromPath(path: string): ModeSliceState["value"] {
  if (path.includes("region")) return "region";
  if (path.includes("alert")) return "alert";
  return "store";
}